
export enum ApiContractImplTechnology {
	JAX_RS = 'JAX-RS',
	PYTHON = 'PYTHON',
	WSO_2 = 'WSO2'}

